const numberToTimeStringObject = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / (60 * 60));

  const divisor_for_minutes = totalSeconds % (60 * 60);
  const minutes = Math.floor(divisor_for_minutes / 60);

  const divisor_for_seconds = divisor_for_minutes % 60;
  const seconds = Math.ceil(divisor_for_seconds);

  return {
    hours,
    minutes,
    seconds,
  };
};

export const GENERAL_MAX_LENGTH = 255;
export const EMAIL_MAX_LENGTH = 255;
export const NAME_MAX_LENGTH = 50;

export { numberToTimeStringObject };
